<!-- Start <search-form> -->
<div class="app-wrapper">
    <ng-container
            *ngIf="itineraryChangeInformation || itineraryChangeInformationError.active === true || isItineraryChangeInformationLoader">
        <card [isCollapsible]="true">
            <div class="card-header-content">
                <h1 *ngIf="itineraryChangeInformation && !isItineraryChangeInformationLoader">
                    {{(Yii.t('wui-iqba-js', 'Dossier')) + '&nbsp;' + itineraryChangeInformation.code + '&nbsp;' + itineraryChangeInformation.host}}
                </h1>
                <btn class="back-to" type="actionUndo" *ngIf="itineraryChangeInformation"
                     (click)="returnToSasha()"
                     [label]="wording.backToSasha"></btn>
                <div *ngIf="!itineraryChangeInformation && !isItineraryChangeInformationLoader">{{Yii.t('wui-iqba-js', 'Erreur')}}</div>
                <div *ngIf="isItineraryChangeInformationLoader">{{Yii.t('wui-iqba-js', 'Chargement...')}}</div>
            </div>

            <div class="card-body-content card-marge-inside">
                <app-itinerary-change-information
                        *ngIf="itineraryChangeInformation && !isItineraryChangeInformationLoader"
                        [itineraryChangeInformation]="itineraryChangeInformation"
                        [addPrice]="addPrice"></app-itinerary-change-information>
                <notification *ngIf="!itineraryChangeInformation && !isItineraryChangeInformationLoader"
                              type="{{ itineraryChangeInformationError.type }}"
                              class="flex-1">
                    {{ itineraryChangeInformationError.message }}
                </notification>
                <loader *ngIf="isItineraryChangeInformationLoader"
                        [message]="wording.isItineraryChangeInformationLoaderMessage"></loader>
            </div>
        </card>
    </ng-container>


    <div [hidden]="!(isShowAncillaryServices && showServicesContent && isUseServices)"
         *permissionIf="airPermissions.SHARED_AIR_BOOKING_ANCILLARY_SERVICES_USE">
        <ancillary-services-page [servicesSelection]="serviceSelection"
                                 [showPage]="isShowAncillaryServices"
                                 [actualFareFamily]="actualFareFamily"
                                 [segmentsForServices]="segmentsForServices"
                                 [seatMapResponse]="seatMapResponse"
                                 [travellers]="propalResponse.traveller"
                                 (onExit)="resetServiceSelection()"
                                 (onNoServices)="showAncillaryServicesError()"
                                 (onError)="showAncillaryServicesError($event)"
                                 (onValidate)="showQuoteWithServiceSelection($event)"></ancillary-services-page>
    </div>
    <ng-container *ngIf="!isShowAncillaryServices && showServicesContent && ancillaryServicesNotification.active">
        <notification class="ancillary-services-notification"
                      *ngIf="ancillaryServicesNotification.active"
                      [type]="ancillaryServicesNotification.type"
                      [showCloseButton]="true">{{ancillaryServicesNotification.message}}
        </notification>

    </ng-container>
    <div *ngIf="!isShowAncillaryServices">
        <breadcrumb [items]="bcItems" (notify)="bcNavigate( $event )" *ngIf="bcItems.length > 1"></breadcrumb>
        <!-- only when no Post And no id in URL -->
        <card *ngIf="(!isPost && !idSearch) && !searchFormUse" [class.hidden]="!bcIsActive('searchTile')">
            <!-- only when no Post And no id in URL -->
            <div class="card-header-content">
                <h1>{{Yii.t('wui-iqba-js', 'Recherche d\'itinéraire')}}</h1>
                <btn class="back-to" type="actionUndo" *ngIf="isFromWatabi"
                     (click)="returnToWatabi()"
                     [label]="wording.backToSasha"></btn>
            </div>
            <div class="card-body-content card-marge-inside" *ngIf="!searchFormUse">
                <message [value]="Yii.t('wui-iqba-js', 'données de recherche manquantes')"></message>
            </div>
        </card>
        <air-search (onSubmitSearch)="submitSearch($event)" [searchErrorMessage]="searchErrorMessage"></air-search>
        <notification *ngIf="dictionaryRoutesHostsErrorMessage" [type]="notificationType.Error" class="flex-1">
            {{ dictionaryRoutesHostsErrorMessage }}
        </notification>
    </div>

    <div [hidden]="!(isShowAncillaryServicesSelection && serviceSelection && showServicesContent)">
        <ng-container *permissionIf="airPermissions.SHARED_AIR_BOOKING_ANCILLARY_SERVICES_USE">
            <ancillary-services-summary [selection]="serviceSelection"
                                        [canCreateBooking]="validTraveller(propalResponse.traveller) && !loader.active"
                                        (onCreate)=" handleBooking()"></ancillary-services-summary>
        </ng-container>
    </div>

    <ng-container *ngIf="missingPermission">
        <card>
            <div class="card-header-content">
                <h1>{{Yii.t('wui-iqba-js', 'Permission manquante')}}</h1>

                <div class="no-wrap">
                    <btn *ngIf="searchFormUse"
                         type="actionDo"
                         [label]="Yii.t('wui-iqba-js', 'Lancer une recherche')"
                         (onClick)="missingPermission = false; bcNavigate({'name': 'searchPage'}); showFlightForm = true;"></btn>
                </div>
            </div>

            <div class="card-body-content">
                <notification type="error" class="flex-1">
                    {{Yii.t('wui-iqba-js', 'Impossible d\'effectuer l\'action voulue, une permission est manquante')}}
                </notification>
            </div>

        </card>
    </ng-container>

    <ng-container *ngIf="savingOffer.show">
        <card>
            <div class="card-header-content">
                <h1>{{wording.saveAnOffer}}</h1>

                <div *ngIf="savingOffer.done && !isGetOfferContext" class="no-wrap">

                    <btn *ngIf="onOfferSelectedExternalLink?.button?.show"
                         type="actionMore"
                         class="others-propositions"
                         [label]="onOfferSelectedExternalLink.button?.text"
                         (onClick)="redirectToExternalLink(onOfferSelectedExternalLink)">
                    </btn>

                    <btn *ngIf="!savingOffer.error?.active"
                         class="others-propositions"
                         [label]="wording.autresPropositions"
                         type="actionMore"
                         (onClick)="resetSaveOffer(); showQuotes = true; notes = []"></btn>

                    <btn *ngIf="searchFormUse"
                         type="actionDo"
                         [label]="Yii.t('wui-iqba-js', 'Modifier la recherche')"
                         (onClick)="resetSaveOffer(); bcNavigate({'name': 'searchPage'}); showFlightForm = true;"></btn>
                </div>
            </div>

            <div class="card-body-content">
                <notification *ngIf="savingOffer.done && savingOffer.error?.active && !savingOffer.warning?.active"
                              type="error"
                              class="flex-1">
                    {{savingOffer.error.message}}
                </notification>

                <notification *ngIf="savingOffer.done && !savingOffer.error?.active && savingOffer.warning?.active"
                              type="warning"
                              class="flex-1 e2e-success-save-offer">
                    {{savingOffer.warning.message}}
                </notification>

                <notification *ngIf="savingOffer.done && !savingOffer.error?.active && !savingOffer.warning?.active"
                              type="success"
                              class="flex-1 e2e-success-save-offer">
                    {{Yii.t('wui-iqba-js', 'Sauvegarde d\'une offre réussie')}}
                </notification>

                <loader *ngIf="loader.active" [message]="loader.message"></loader>
                <div [attr.data-target]="saveOfferId" class="e2e-input-booking-id hidden-e2e-tag"></div>
            </div>

        </card>
    </ng-container>

    <ng-container *ngIf="silentBook.show">
        <card>
            <div class="card-header-content">
                <h1>{{Yii.t('wui-iqba-js', 'Réservation d\'une offre sauvegardée')}}</h1>
            </div>

            <div class="card-body-content">
                <loader *ngIf="loader.active" [message]="loader.message"></loader>

                <ng-container *ngIf="silentBook.done">
                    <notification *ngIf="silentBook.error.active" type="error" class="flex-1">
                        {{silentBook.error.message}}
                    </notification>

                    <notification *ngIf="silentBook.warning" type="warning" class="flex-1">
                        {{wording.silentBookingWarning}}
                    </notification>

                    <notification *ngIf="silentBook.success"
                                  type="success e2e-success-save-booking-offer"
                                  class="flex-1">
                        {{wording.silentBookingSuccess}}
                    </notification>
                </ng-container>
            </div>
        </card>
    </ng-container>

    <best-quotes *ngIf="showQuotes && searchSent && !isShowAncillaryServices"
                 [bestQuotes]="propalResponse?.data?.bestQuotes"
                 [dictionary]="propalResponse?.data?.dictionary"
                 [originalRequest]="originalRequest"
                 [tripId]="propalResponse?.data?.key"
                 [fareFamilyDictionary]="propalResponse?.data?.dictionary?.fareFamily"
                 [isOfferSelection]="isOfferSelection()"
                 [isModifySegment]="contextIsModifySegment"
                 (onAlternativeSelect)="selectAlternative($event)"
                 (onBook)="selectQuote($event); showQuotes = false"
                 [sessionPostOnUpdateBooking]="sessionPostOnUpdateBooking"></best-quotes>

    <quote-list *ngIf="showQuotes && searchSent  && !isShowAncillaryServices"
                [tripId]="propalResponse?.data?.key"
                [price]="price"
                [selectedQuoteId]="propalResponse?.display?.booking"
                [originalRequest]="originalRequest"
                [errorMessage]="searchErrorMessage"
                [isOfferSelection]="isOfferSelection()"
                [isModifySegment]="contextIsModifySegment"
                [vccPermission]="showLowcostBook && !contextIsModifySegment"
                [ndcPermission]="showNDCBook"
                [mustRedirectAfterSelection]="!contextIsModifySegment"
                [sessionPostOnUpdateBooking]="sessionPostOnUpdateBooking"
                (onClose)="toggleQuotes(); showQuotes = false"
                (onSelectQuote)="selectQuote($event); showQuotes = false"
                (onSelectedQuoteOnly)="selectQuote($event)"
                (onAlternativeSelect)="selectAlternative($event)"
                (onSelectOtherFlight)="selectOtherFlight($event)"></quote-list>

    <!-- Itinerary Card -->
    <ng-container
            *ngIf="!showQuotes && !savingOffer.show && !silentBook.show && !isShowAncillaryServices && !missingPermission">
        <card *ngIf="propalResponse.data || (propalResponse.traveller | keys).length > 0 || traveller.length > 0 || searchSent"
              [class.hidden]="!bcIsActive('itineraryTile')">

            <div class="card-header-content">
                <h1 class="title-flex-inline">
                    <div class="title-flex-inline-principal">
                        {{isGetOfferContext ? wording.offerGotten : wording.itineraire}}
                    </div>
                    <strong *ngIf="propalResponse.data && propalResponse.data.booking && propalResponse.data.booking[propalResponse.display.booking].title"
                            class="quotes-title title-flex-inline-additional">
                        {{ propalResponse.data.booking[propalResponse.display.booking].title }}
                    </strong>
                </h1>

                <div *ngIf="propalResponse.data" class="no-wrap">
                    <btn [class.hidden]="!bcIsActive('itineraryTile.allFlightsButton')"
                         *ngIf="isJourney() && priceStillValid"
                         class="others-flights"
                         [label]="wording.autresVols"
                         type="actionHeaderLink"
                         classList="no-spacing"
                         (onClick)="openAllSegments(propalResponse.display.booking)"></btn>

                    <btn [class.hidden]="!bcIsActive('itineraryTile.quotesButton')"
                         class="others-propositions"
                         [label]="wording.autresPropositions"
                         type="actionMore"
                         (onClick)="showQuotes = true; resetServiceSelection(); addPrice = null; notes = []"></btn>

                    <btn [class.hidden]="!bcIsActive('itineraryTile.searchEditButton')"
                         *ngIf="searchFormUse"
                         type="actionDo"
                         [label]="Yii.t('wui-iqba-js', 'Modifier la recherche')"
                         (onClick)="bcNavigate({'name': 'searchPage'}); showFlightForm = true;"></btn>

                    <btn *ngIf="searchFormUse && !priceStillValid"
                         type="actionDo"
                         [label]="Yii.t('wui-iqba-js', 'Relancer la recherche')"
                         (onClick)="searchAgain();"></btn>

                    <btn *ngIf="showSaveButton() && !propalResponse.message && propalResponse.data"
                         class="save-select-offer e2e-select-offer"
                         [label]="wording.selectionnerProposition"
                         (onClick)="saveOffer()"
                         [disableIf]="loader?.active"
                         type="actionMore"></btn>

                    <ng-container *ngIf="showBookButtons() && !contextIsModifySegment">

                        <btn [label]="wording.reserverVoyage"
                             (onClick)="showTravellerForm('T_1')"
                             type="actionPrincipal e2e-booking-btn"
                             *ngIf="(propalResponse.data ) && bcIsActive('itineraryTile.nextPageButton') && isPerm('booking.create') && priceStillValid"
                             class="booking-create"></btn>

                        <!-- when travellers can be modified -->
                        <btn *ngIf="bcIsActive('itineraryTile.bookingButton')  && isPerm('booking.create') && isPerm('travellerTile.edit') && priceStillValid"
                             class="booking-create e2e-booking-btn"
                             type="actionPrincipal"
                             [label]="wording.reserverVoyage"
                             [disableIf]="loader?.active"
                             [popInfo]="!canCreatePNR ? Yii.t('wui-iqba-js', 'Vérifier les données voyageurs') : null"
                             (onClick)="(travellerFormTemplate?.form?.valid || validTraveller(propalResponse.traveller)) && !loader.active ? handleBooking() : getTravellerFormValidity()"
                        ></btn>

                        <!-- when travellers can't be modified -->
                        <btn *ngIf="bcIsActive('itineraryTile.bookingButton')  && isPerm('booking.create') && !isPerm('travellerTile.edit') && priceStillValid"
                             type="actionPrincipal e2e-booking-btn"
                             class="booking-create"
                             [popInfo]="!canCreatePNR ? Yii.t('wui-iqba-js', 'Vérifier les données voyageurs') : null"
                             [disableIf]="loader?.active"
                             [label]="wording.reserverVoyage"
                             (onClick)="(travellerFormTemplate?.form?.valid || validTraveller(propalResponse.traveller)) && !loader.active ? handleBooking(): getTravellerFormValidity()"
                        ></btn>

                    </ng-container>

                    <btn *ngIf="contextIsModifySegment && priceStillValid && selectSectorMatchFolder?.nbSameSector === 0"
                         type="actionPrincipal e2e-booking-btn"
                         class="booking-modify"
                         [disableIf]="loader?.active"
                         [label]="wording.modifySegmentButtonLabel"
                         (onClick)="updateBooking()"
                    ></btn>
                </div>
            </div>

            <span class="card-body-content">
                <div class="propal-wrapper single-propal">
                    <loader *ngIf="!propalResponse.message && !propalResponse.data"
                            [message]="isGetOfferContext ? wording.offerGetLoading : wording.rechercheencours">
                    </loader>
                    <loader *ngIf="loader.active" [message]="loader.message"></loader>

                    <notification *ngIf="propalResponse.warningMessage && !loader.active"
                                  type="warning"
                                  class="flex-1">
                        {{propalResponse.warningMessage}}
                    </notification>

                    <notification *ngIf="propalResponse.message"
                                  type="error"
                                  class="flex-1">
                        {{propalResponse.message}}
                    </notification>

                    <notification *ngIf="pnrCreationError?.active" [type]="notificationType.Error" [title]="pnrCreationError?.message" [isCode]="true">
                        {{pnrCreationError?.technicalMessage}}
                    </notification>
                    <div class="propal-content" *ngIf="!loader.active && propalResponse.data" #bookingContainer>
                        <div class="propal-content-body">
                            <booking #bookingComponent
                                     *ngIf="loaded && propalResponse.data.selectedQuote"
                                     [useServices]="true"
                                     [key]="propalResponse.display.booking"
                                     [bookingItem]="propalResponse.data.selectedQuote"
                                     [selectedJourneys]="propalResponse.data.selectedQuoteJourneys"
                                     [beginDaysDifference]="propalResponse.data.booking[propalResponse.display.booking]?.beginDaysDifference"
                                     [fareFamilyDictionary]="propalResponse.data.dictionary?.fareFamily"
                                     [price]="price"
                                     [carrier]="carrier"
                                     [carriers]="propalResponse.data.dictionary.carrier"
                                     [originalRequest]="originalRequest"
                                     separator="row-2"
                                     [showFlightDetails]="showFlightDetails"
                                     [selectSectorMatchFolder]="selectSectorMatchFolder"
                                     (onLoaded)="compactSelectBookingData()">
                                <div class="booking-bottom">
                                    <ng-container *permissionIf="offerAlternativesPermission; airQuote propalResponse.data.selectedQuote">
                                        <btn *ngIf="hasAlternativeFares && !isGetOfferContext"
                                             [label]="isAlternativeFaresVisible ? wording.hideAlternativeFares : wording.showAlternativeFares"
                                             type="actionPrincipal"
                                             (click)="toggleAlternativeFares($event)">
                                        </btn>
                                    </ng-container>

                                </div>
                            </booking>
                        </div>
                        <ng-container *ngIf="isAlternativeFaresVisible">
<!--                                    [sqaId]="idSearch"-->
                            <fare-family-benchmark
                                    [sqaId]="propalResponse.data?.key"
                                    [quoteId]="propalResponse.display.booking"
                                    [fareFamilyDictionary]="propalResponse.data.dictionary?.fareFamily"
                                    [parentWidth]="containerWidth"
                                    [segments]="selectedSegments"
                                    [selectedJourneys]="propalResponse.data.selectedQuoteJourneys"
                                    [fareFamilySelectionXId]="selectedFareFamilyXId"
                                    [sessionPostOnUpdateBooking]="sessionPostOnUpdateBooking"
                                    [mustRedirectAfterSelection]="!contextIsModifySegment"
                                    (onAlternativeSelect)="selectAlternative($event)"></fare-family-benchmark>
                        </ng-container>
                    </div>

                </div>

            </span>

            <span class="card-footer-content"></span>

        </card>

    </ng-container>

    <div [hidden]="!((isShowAncillaryServicesSelection && serviceSelection && showServicesContent) || (bookingWithSelection && !showQuotes && showServicesContent))">
        <ng-container *permissionIf="airPermissions.SHARED_AIR_BOOKING_ANCILLARY_SERVICES_USE">
            <ancillary-services-list
                    [selection]="serviceSelection"
                    [bookingWithSelection]="bookingWithSelection"
                    (onEdit)="navigateToAncillaryServices()"></ancillary-services-list>
        </ng-container>
    </div>

    <ng-container
            *ngIf="!showQuotes && !savingOffer.show && !silentBook.show && !isShowAncillaryServices && !missingPermission">
        <div class="traveller-ssr-wrapper card-marge-wrapper"
             *ngIf="showPNRForm"
             [class.wrapper-col]="propalResponse.traveller !== null && (propalResponse.traveller | keys).length > 3">


            <travellerForm #travellerFormTemplate
                           *ngIf="( (propalResponse.traveller !== null && (propalResponse.traveller | keys).length > 0) || traveller.length > 0 || quantity ) && bcIsActive('travellerTile') && isPerm(['searchPage.travellerTile.edit', 'searchPage.travellerTile.view'])"
                           [travellerItem]="getTravellers()"
                           [actionArray]="propalResponse.data?.selectedQuote?.actionArray"
                           [useApis]="true"
                           [columns]="( (propalResponse.traveller !== null && propalResponse.traveller | keys).length > 3)|| traveller.length > 3 || quantity > 3"
                           [contextIsModifySegment]="contextIsModifySegment"
                           (isInvalid)="checkTravellersFormValidity($event)"
                           (onGetTravellerInformations)="setTravellers($event)"
                           class="flex-1">
            </travellerForm>

            <travellerCard
                    [travellerList]="propalResponse.traveller"
                    [showErrors]="true"
                    class="flex-1"
                    *ngIf="( (propalResponse.traveller !== null && (propalResponse.traveller | keys).length > 0) || traveller.length > 0 || quantity ) && bcIsActive('travellerTile') && isPerm(['!searchPage.travellerTile.edit', 'searchPage.travellerTile.view'])">
            </travellerCard>

            <!-- SSR Card -->
            <div class="right-col">

                <permission [path]="airPermissions.SHARED_AIR_BOOKING_ANCILLARY_SERVICES_USE"
                            *ngIf="!isShowAncillaryServicesSelection && isUseServices">
                    <card class="has-permission right-col-component">
                        <div class="card-header-content">
                            <h1>{{wording.servicesAnnexes}}</h1>
                        </div>
                        <div class="card-body-content card-marge-inside">
                            <btn *permissionIf="airPermissions.SHARED_AIR_BOOKING_ANCILLARY_SERVICES_USE"
                                 type="actionPrincipal"
                                 style="display:block; margin-bottom: 1em;"
                                 [value]="wording.servicesAnnexes"
                                 (onClick)="navigateToAncillaryServices()">
                            </btn>
                        </div>
                    </card>
                    <card class="right-col-component"
                          [class.hidden]="!bcIsActive('ssrTile') "
                          *ngIf="( (propalResponse.traveller !== null && (propalResponse.traveller | keys).length > 0)) || traveller.length > 0 || (quantity && quantity.adult )">
                        <div class="card-header-content">
                            <h1>{{wording.ssr}}</h1>
                            <btn type="actionHeaderLink"
                                 classList="no-spacing"
                                 [label]="Yii.t('wui-iqba-js', 'Voir les demandes')"
                                 (click)="showSSR = !showSSR"></btn>
                        </div>

                        <span class="card-body-content"
                              *ngIf="(propalResponse.traveller | keys).length > 0 || traveller.length > 0">
                      <ssr [ssrList]="ssrResponse.data"
                           [travellerName]="travellerName"
                           [traveller]="propalResponse.traveller"
                           [ssrImport]="ssrResponse.decodedSsr"
                           (SSRSelected)="selectSSRHub($event)"
                           [showSSR]="showSSR"></ssr>
                  </span>
                        <span class="card-body-content" *ngIf="!travellerFormData">
                      <ssr [ssrList]="ssrResponse.data"
                           [travellerName]="travellerName"
                           [traveller]="propalResponse.traveller"
                           (SSRSelected)="selectSSRHub($event)"
                           [showSSR]="showSSR"></ssr>
                  </span>
                    </card>


                    <card class="right-col-component has-no-permission"
                          [class.hidden]="!bcIsActive('ssrTile') "
                          *ngIf="( (propalResponse.traveller !== null && (propalResponse.traveller | keys).length > 0)) || traveller.length > 0 || (quantity && quantity.adult )">
                        <div class="card-header-content">
                            <h1>{{wording.ssr}}</h1>
                            <btn type="actionHeaderLink"
                                 classList="no-spacing"
                                 [label]="Yii.t('wui-iqba-js', 'Voir les demandes')"
                                 (click)="showSSR = !showSSR"></btn>
                        </div>

                        <span class="card-body-content"
                              *ngIf="(propalResponse.traveller | keys).length > 0 || traveller.length > 0">
                      <ssr [ssrList]="ssrResponse.data"
                           [travellerName]="travellerName"
                           [traveller]="propalResponse.traveller"
                           [ssrImport]="ssrResponse.decodedSsr"
                           (SSRSelected)="selectSSRHub($event)"
                           [showSSR]="showSSR"></ssr>
                  </span>
                        <span class="card-body-content" *ngIf="!travellerFormData">
                      <ssr [ssrList]="ssrResponse.data"
                           [travellerName]="travellerName"
                           [traveller]="propalResponse.traveller"
                           (SSRSelected)="selectSSRHub($event)"
                           [showSSR]="showSSR"></ssr>
                  </span>
                    </card>
                </permission>

                <ng-container *permissionIf="notepadEditorPermission">
                    <card class="right-col-component"
                          *ngIf="( (propalResponse.traveller !== null && (propalResponse.traveller | keys).length > 0) || traveller.length > 0 || quantity ) && bcIsActive('travellerTile') && isPerm(['searchPage.travellerTile.edit', 'searchPage.travellerTile.view'])">
                        <div class="card-header-content">
                            <h1>{{wording.notes}}</h1>
                        </div>
                        <div class="card-body-content">
                            <notepad #notepadComponent
                                     [displayMode]="'CREATE'"
                                     [isEditPermission]="isNotepadPermission"
                                     [isLengthRestriction]="true"
                                     [updateNotes]="false"
                                     [isAlwaysEditable]="true"
                                     [notes]="notes"
                                     [isEditable]="!contextIsModifySegment"
                                     (onEdit)="storeNotes()">
                            </notepad>
                        </div>
                    </card>
                </ng-container>
            </div>
        </div><!-- /card-row -->

    </ng-container>


</div>

<!-- Quotes Modal -->
<modal #quotesModal class="autresPropositions">

    <div class="modal-header-content">
        <div class="header-criteria">
            {{ quoteResponse.data.quantity ? wording.autresPropositions : '...' }}
            <div *ngIf="quoteResponse.data.quantity"
                 class="flex criteres-part">
                <btn type="actionDo" [label]="Yii.t('wui-iqba-js', 'Filtrer')"
                     [ngClass]="{ 'filtering': quoteResponse.display.bookingList.length != quoteResponse.data.quantity.booking }"
                     (click)="showCriteres = !showCriteres"></btn>
                <btn type="actionUndo" [label]="Yii.t('wui-iqba-js', 'Fermer')" (click)="quotesModal.hide()"></btn>
            </div>
        </div>
        <div class="criteres" *ngIf="showCriteres && getFilterData()">
            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="wording.horairesDeparts"
                              type="time"
                              filter="begin"
                              inputType="slider"></quote-filter>
            </div>
            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="wording.horairesArrivees"
                              type="time"
                              filter="end"
                              inputType="slider"></quote-filter>
            </div>

            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="wording.durrees"
                              type="duration"
                              filter="duration"
                              inputType="slider"></quote-filter>
            </div>
            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="wording.durreesEscales"
                              type="duration"
                              filter="durationStop"
                              inputType="slider"></quote-filter>
            </div>

            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="wording.tarifsADT"
                              type="price"
                              filter="price"
                              [root]="true"
                              inputType="slider"
                              position="left"></quote-filter>
            </div>
            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="wording.compagnies"
                              filter="carrier"
                              inputType="checkbox"
                              position="left"></quote-filter>
            </div>
            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="wording.fareType"
                              filter="fareType"
                              [root]="true"
                              inputType="checkbox"
                              position="left"></quote-filter>
            </div>
            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="Yii.t('wui-iqba-js', 'Flexibilité')"
                              filter="beginPlusOrMinus"
                              type="mediumDate"
                              [root]="true"
                              inputType="checkbox"
                              position="left"></quote-filter>
            </div>
            <div class="criteres-part">
                <quote-filter [appliedFilter]="getAppliedFilter()"
                              [filterData]="getFilterData()"
                              [label]="Yii.t('wui-iqba-js', 'Nombre d\'escales')"
                              filter="stop"
                              [root]="false"
                              inputType="checkbox"
                              position="right"></quote-filter>
            </div>

        </div>
    </div>
    <div class="modal-body-content">
        <loader *ngIf="!quoteResponse.data.quantity" message="Chargement en cours"></loader> <!-- Yii -->

        <ng-container *ngIf="quoteResponse.data.quantity">
            <ng-container *ngFor="let bookingKey of quoteResponse.display.bookingList">
                <div class="booking-marker"
                     [ngClass]="{ 'booking-selected': bookingKey == propalResponse.display.booking, 'booking-clicked': bookingClicked === bookingKey }"
                     style="position: relative">
                    <fa-icon [icon]="iconCaret" *ngIf="bookingKey == propalResponse.display.booking"></fa-icon>
                    <booking
                            *ngIf="loaded"
                            [key]="bookingKey"
                            [bookingItem]="quoteResponse.data.booking[bookingKey]"
                            [selectedJourneys]="quoteResponse.display.selectedJourneys[bookingKey]"
                            [beginDaysDifference]="quoteResponse.data.booking[bookingKey]?.beginDaysDifference"
                            [carrier]="carrier"
                            [price]="price"
                            (click)="selectQuote(bookingKey); quotesModal.hide();"
                            [originalRequest]="originalRequest">
                        <div class="booking-additionnal-content-btn">
                            <btn [label]="wording.detailVols"
                                 type="actionMore"
                                 (click)="this.showQuoteSectorsModal(bookingKey)"></btn>
                            <btn *ngIf="isJourney(bookingKey)"
                                 [label]="wording.autresVols"
                                 type="actionMore"
                                 (click)="showOtherPlain(bookingKey)"></btn>
                        </div>
                    </booking>
                </div>
            </ng-container>
            <message
                    type="warning"
                    [value]="wording.message_aucunePropal"
                    *ngIf="quoteResponse.display.bookingList.length == 0">
            </message>
        </ng-container>
    </div>
</modal>


